import { Brick, registerBrick, Transaction, Query, Predicate, Auth, User } from 'olympe';
import ApplicationEvent from './models/Application Event'
export default class LogApplicationEventImpl extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} errorType
     * @param {string} message
     * @param {string} payload
     * @param {boolean} persist
     * @param {function()} forwardEvent
     * @param {function(*)} setObject
     * @param {function(*)} setErrorFlow
     */
    async update($, [ errorType, message, payload, persist], [forwardEvent, setObject, setErrorFlow]) {
        const t = new Transaction(persist);
        const userTag = Auth.getCurrentUser();
        const result = await Query.fromTag(userTag, User).execute();
        const createdBy = result.getFirst().toObject(true).name;
        // 1st - Remove all the logs that are from 30 days ago
        const date = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
        const query = Query.instancesOf(ApplicationEvent).filter(Predicate.smallerThan(ApplicationEvent.createdOnProp, date))
        const queryResult = await query.execute();
        queryResult.forEach((entry) => {
            t.delete(entry);
        })

        // 2nd - Auto-generate code
        const safe = await this.getUniqueCode();

        // 3rd - Add new ApplicationError
        const tag = ApplicationEvent.create(t);
        const now = new Date();

        ApplicationEvent.setCreatedOn(t, tag, now);
        ApplicationEvent.setEventType(t, tag, errorType);
        ApplicationEvent.setMessage(t, tag, message);
        ApplicationEvent.setPayload(t, tag, payload);
        ApplicationEvent.setEventCode(t, tag, safe);
        ApplicationEvent.setCreatedBy(t, tag, createdBy);

        t.execute().then((res) => {
            setObject(res.getCreatedObjects()[0]);
            forwardEvent();
        }).catch((err) => {
            setErrorFlow(err);
        });
    }

    // Generate random code
    generateRandomCode() {
        return btoa(Math.random().toString()).replace(/[+/=]/g, '').slice(0, 12);
    }

    // check if random code already exists
    async getUniqueCode() {
        // 10 is max number of retries
        for (let i = 0; i < 10; i++) {
            const code = this.generateRandomCode();

            const existsResult = await Query
                .instancesOf(ApplicationEvent)
                .filter(Predicate.equals(ApplicationEvent.eventCodeProp, code))
                .execute();

            const exists = Boolean(existsResult.getFirst());
            if (!exists) return code;
        }
        throw new Error('Could not generate a unique code after multiple attempts');
    }
}

registerBrick('0199863ec86ac4b2804f', LogApplicationEventImpl);
